<template>
  <vs-select
    class="w-full"
    label="Listing"
    v-model="selected"
    autocomplete
  >
    <vs-select-item
      :key="index"
      :value="item"
      :text="item.name"
      v-for="(item,index) in arrayData"
    />
  </vs-select>
</template>

<script>
import store from '@/store/store'

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          id: '',
        }
      }
    }
  },
  data () {
    return { store }
  },
  computed: {
    arrayData: {
      get () {
        return this.store.getters['listing/arrayData']
      }
    },
    selected: {
      get () {
        return this.data.name
      },
      set (val) {
        this.$emit('change', {
          id: val.id,
          name: val.name || '',
          titleId: val.titleId || '',
          titleEn: val.titleEn || '',
          excerptId: val.excerptId || '',
          excerptEn: val.excerptEn || '',
          noContract: val.noContract || '',
          category: val.category,
          logoUrl: val.logoUrl || '',
          email: val.email || '',
          phones: val.phones || [],
          phone: val.phone || '',
          address: val.address || '',
          workHour: val.workHour || '',
          sosmedLinks: val.sosmedLinks || '',
          thumbnailUrl: val.thumbnailUrl || '',
        })
      }
    }
  }
}
</script>
